import React, { Component } from "react"
import { Forms } from "../../styleguide/js/components/forms"
class TravelGuideStep2 extends Component {
  constructor(props) {
    super(props)
    this.formRef = React.createRef()
    this.state = {
      invalidData: false,
      travelsWithLuggage: undefined,
      travelsWithChildren: undefined,
      travelForm: undefined,
      doScrollToTop: true,
    }
  }
  componentDidMount() {
    const { travelsWithChildren, travelsWithLuggage, travelForm } = this.props
    if (travelsWithChildren || travelsWithChildren === false || travelsWithChildren === null) this.setState({ travelsWithChildren })
    if (travelsWithLuggage || travelsWithLuggage === false || travelsWithLuggage === null) this.setState({ travelsWithLuggage })
    if (travelForm || travelForm === null) this.setState({ travelForm })
    if (this.formRef.current) new Forms({ el: this.formRef.current })
    if (this.formRef.current) setTimeout(this.formRef.current.scrollIntoView({ behavior: "smooth", block: "start" }))
  }
  componentDidUpdate(prevPros) {
    const { travelsWithChildren, travelsWithLuggage, travelForm } = this.props
    if (prevPros.travelsWithChildren !== travelsWithChildren) this.setState({ travelsWithChildren })
    if (prevPros.travelsWithLuggage !== travelsWithLuggage) this.setState({ travelsWithLuggage })
    if (prevPros.travelForm !== travelForm) this.setState({ travelForm })
    if (this.formRef.current) new Forms({ el: this.formRef.current })
    if (this.formRef.current && this.state.doScrollToTop)
      this.setState({ doScrollToTop: false }, () => setTimeout(this.formRef.current.scrollIntoView({ behavior: "smooth", block: "center" })))
  }

  render() {
    const { config } = this.props
    const { invalidData, travelsWithChildren, travelsWithLuggage, travelForm } = this.state

    return (
      <React.Fragment>
        <div className="w--wider">
          <div className="form form-padding-top" ref={this.formRef}>
            <div className="w--wider">
              <div className="form__section form__section--light">
                <h4>{config.travelWithLuggageText || "Rejser du med indchecket bagage"}</h4>
                <div className="form__section__inner">
                  <div className="form__field form__field--radio is-bound">
                    <label className="form__label no-text-transform">
                      <input
                        className="form__item "
                        name="travelsWithLuggage"
                        type="radio"
                        defaultChecked={travelsWithLuggage}
                        onChange={() => this.props.writeToState({ travelsWithLuggage: true })}
                      />
                      <span className="form__label__text">
                        <span>{config.yesText || "Ja"}</span>
                      </span>
                    </label>
                  </div>
                  <div className="form__field form__field--radio is-bound">
                    <label className="form__label no-text-transform">
                      <input
                        className="form__item "
                        name="travelsWithLuggage"
                        type="radio"
                        defaultChecked={travelsWithLuggage === false ? true : null}
                        onChange={() => this.props.writeToState({ travelsWithLuggage: false })}
                      />
                      <span className="form__label__text ">
                        <span>{config.noText || "Nej"}</span>
                      </span>
                    </label>
                  </div>
                  <div className="form__field form__field--radio is-bound">
                    <label className="form__label no-text-transform">
                      <input
                        className="form__item "
                        name="travelsWithLuggage"
                        type="radio"
                        defaultChecked={travelsWithLuggage === null ? true : null}
                        onChange={() => this.props.writeToState({ travelsWithLuggage: null })}
                      />
                      <span className="form__label__text ">
                        <span>{config.doNotKnowText || "Ved det ikke endnu"}</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="form__section form__section--light">
                <h4>{config.transportToAirportText || "Transport til lufhavnen"}</h4>

                <div className={`form__field form__field--select is-bound ${travelForm && "is-filled"} ${invalidData && "is-invalid"}`}>
                  <div className="form__container">
                    <span className="form__valid" />
                    <select
                      id="travelForm"
                      className="form__item "
                      aria-label="Select menu"
                      value={travelForm}
                      onChange={(e) => this.props.writeToState({ travelForm: e.currentTarget.value === null ? null : e.currentTarget.value })}
                    >
                      <option value="Bus">{config.transportToAirportBusOptionText || "Bus"}</option>
                      <option value="Driven by another">{config.transportToAirportDriveOptionText || "Kørt"}</option>
                      <option value="Private car (or motorcycle, scooter)">{config.transportToAirportPrivateCarOptionText || "Bil"}</option>
                      <option value="Flight (transit)">{config.transportToAirportPlaneOptionText || "Fly (transit)"}</option>
                      <option value="Metro">{config.transportToAirportMetroOptionText || "Metro"}</option>
                      <option value="Taxi">{config.transportToAirportTaxiOptionText || "Taxi"}</option>
                      <option value="Train">{config.transportToAirportTrainOptionText || "Tog"}</option>
                      <option value="Other">{config.transportToAirportOtherOptionText || "Anden"}</option>
                      <option value="null">{config.doNotKnowText || "Ved det ikke endnu"}</option>
                    </select>
                    <label htmlFor="travelForm" className="form__label">
                      <span className="form__label__text">
                        {config.transportToAirportDropdownLabel || "Vælg transportform"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="form__section form__section--light">
                <h4>{config.travelWithChildrenText || "Rejser du med børn"}</h4>
                <div className="form__section__inner">
                  <div className="form__field form__field--radio is-bound">
                    <label className="form__label no-text-transform">
                      <input
                        className="form__item "
                        name="travelsWithChildren"
                        type="radio"
                        defaultChecked={travelsWithChildren}
                        onChange={() => this.props.writeToState({ travelsWithChildren: true })}
                      />
                      <span className="form__label__text">
                        <span>{config.yesText || "Ja"}</span>
                      </span>
                    </label>
                  </div>
                  <div className="form__field form__field--radio is-bound">
                    <label className="form__label  no-text-transform">
                      <input
                        className="form__item "
                        name="travelsWithChildren"
                        type="radio"
                        defaultChecked={travelsWithChildren === false ? true : null}
                        onChange={() => this.props.writeToState({ travelsWithChildren: false })}
                      />
                      <span className="form__label__text">
                        <span>{config.noText || "Nej"}</span>
                      </span>
                    </label>
                  </div>
                  <div className="form__field form__field--radio is-bound">
                    <label className="form__label no-text-transform">
                      <input
                        className="form__item "
                        name="travelsWithChildren"
                        type="radio"
                        defaultChecked={travelsWithChildren === null ? true : null}
                        onChange={() => this.props.writeToState({ travelsWithChildren: null })}
                      />
                      <span className="form__label__text ">
                        <span>{config.doNotKnowText || "Ved det ikke endnu"}</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="button-container">
                <button
                  className={`button button--small rm-this-class rm-this-class-hide-default no-shadow ${
                    config.goBackButtonBackgroundColor || "button--general is-grey-text"
                  }`}
                  onClick={() => this.props.stepButtonClickHandler({ activeStep: 1, activeTab: 2 })}
                >
                  <span className="icon">
                    <svg className="svg-icon svg-icon--planeduo">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/svg/symbols.svg#svg-planeduo">
                        &nbsp;
                      </use>
                    </svg>
                  </span>
                  <span className="text strong">{config.goBackButtonText || "Tilbage"}</span>
                </button>
                <button
                  className={`button button--small rm-this-class rm-this-class-hide-default no-shadow ${
                    config.nextButtonBackgroundColor || "button--general is-blue-text"
                  }`}
                  onClick={() => this.props.stepButtonClickHandler({ activeStep: 3 })}
                >
                  <span className="icon">
                    <svg className="svg-icon svg-icon--planeduo">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/svg/symbols.svg#svg-planeduo">
                        &nbsp;
                      </use>
                    </svg>
                  </span>
                  <span className="text strong">{config.nextButtonText || "Fortsæt"}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}
export default TravelGuideStep2
